export enum Scale {
  Log = 'log',
  Linear = 'linear',
}

export enum Period {
  Hourly = 'hour',
  Daily = 'day',
  Weekly = 'week',
  Monthly = 'month',
  Quarter = 'quarter',
  Year = 'year',
}
